import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getAll() {
        try {
            //Employees - transfer to Employees Controller
            const response = await axios.get(`Employees`, {
                headers: {
                    'page_key': pageKeys.employees
                }
            })            
            return response
        }catch(error){
            console.log('Employees api getAll error')
            throw error
        }
    },
    async getAllByPageKey(pageKey) {
        try {
            //Employees - transfer to Employees Controller
            const response = await axios.get(`Employees/bypage/${pageKey}`, {
                headers: {
                    'page_key': pageKeys.employees
                }
            })            
            return response
        }catch(error){
            console.log('Employees api getAllByPageKey error')
            throw error
        }
    },
    async get(userId) {
        try {
            //User Profile
            const response = await axios.get(`Employees/${userId}`, {
                headers: {
                    'page_key': pageKeys.employees
                }
            })            
            return response
        }catch(error){
            console.log('Employees api get error')
            throw error
        }
    },

    //replaced with Team Membership
    // async assign(teamData) {
    //     try {
    //         //User Profile
    //         const response = await axios.post(`Employees/assignment`, 
    //         {
    //             teamAssignment : teamData
    //         },
    //         {
    //             headers: {
    //                 'page_key': pageKeys.employees
    //             }
    //         })            
    //         return response
    //     }catch(error){
    //         console.log('Employees api assignment error')
    //         throw error
    //     }
    // },
    
    async getUpload() {
        try {
            const response = await axios.get(`Employees/upload`, {
                headers: {
                    'page_key': pageKeys.employees
                }
            })            
            return response
        }catch(error){
            console.log('Employees getUpload error')
            throw error
        }
    },
    async deleteUpload(userUploadId) {
        try {
            const response = await axios.post(`Employees/upload/delete/${userUploadId}`, 
            {},
            {
                headers: {
                    'page_key': pageKeys.employees
                }
            })            
            return response
        }catch(error){
            console.log('Employees deleteUpload error')
            throw error
        }
    },
    async saveUpload(userUploadId) {
        try {
            const response = await axios.post(`Employees/upload/save/${userUploadId}`, 
            {},
            {
                headers: {
                    'page_key': pageKeys.employees
                }
            })            
            return response
        }catch(error){
            console.log('Employees saveUpload error')
            throw error
        }
    },
    async getEmployeesStatusReport() {
        try
        {            
            const response = await axios.get(`Employees/status/xls`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.employees
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Employees api getEmployeesStatusReport error')
            throw error
        }
    },
}